import { chatbotMessage } from '@csi-monorepo/constants/chatbot';
import { assistantRoleType } from '@src/types/chatbot';

export const initialMessage = [
  {
    role: assistantRoleType.ASSISTANT,
    content: chatbotMessage,
  },
];
